module.exports = __webpack_public_path__ + "img/individual_weddingrings_ring_2@2x.74b76e1.jpg";